<!-- 无权限展示页面 -->
<template>
  <div class="zk-wrap">
    <div class="three-areas" v-if="isEclpSeller()">
      <h3>
        本功能仅限{{versions}}使用，请前往京麦服务市场订购服务
        <a target="_blank" href="//fw.jd.com/772005.html">
          <Button type="primary">服务订购</Button>
        </a>
      </h3>
    </div>
    <div class="three-areas" v-if="!isEclpSeller()">
      <h3>
        您没有访问此页面的权限，如有问题，可联系运维
      </h3>
    </div>
    <div class="three-areas">
      <img v-for="(imgSrc,index) in imgSrcs" :key="index" :src="'/images/perm'+imgSrc" alt="">
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import ComUrl from '../../request/common'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    user: {
      type: Object
    }
  },
  data () {
    // 这里存放数据
    return {
      imgSource: {
        '/home': ['/images/perm/home/1.png', '/images/perm/home/2.png', '/images/perm/home/3.png']
      },
      imgSrcs: [],
      versions: null,
      userData: this.user
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    isEclpSeller () {
      return this.userData.userType === '2' && this.userData.tenantId === '1'
    },
    getOninit (user) {
      if (user) {
        this.userData = user
      }
      let url = this.$route.path
      // console.log(url, this.userData)
      this.imgSrcs = this.imgSource[Object.keys(this.imgSource).find(d => url.startsWith(d))] || []
      if (this.isEclpSeller()) {
        // 查询当前菜单对应的版本！
        ComUrl.getVersions({ checkUrl: url }).then(data => {
          if (data.success) {
            this.versions = (data.body || []).map(d => d.name).join(',')
          }
        })
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getOninit()
  }
}
</script>
<style lang='scss' scoped>
  // @import url(); 引入公共css类
  .zk-wrap {
    background-color: #f9f9fe;
    min-height: 800px;
    min-width: 1200px;
    font-family:'dinregular', "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
    text-align: center;
  }
  .three-areas {
    margin: 0 auto;
    // a: 14px;
    background-color: #fff;
    border: solid 1px #f0f0f5;
    // margin-bottom: 10px;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0px, 0px, 6px, rgba(44, 56, 90, 0.08);
    h3{
      margin: 10px;
      color: red;
      font-weight: bold;
    }
    img{
      width: 100%;
      padding: 10px 10px 0 10px;
    }
    img:last-of-type{
      padding-bottom:10px;
    }
  }
</style>
